import { useMemo } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FormControl, FormLabel, Box } from "@chakra-ui/react";

interface HtmlEditorFieldProps {
    label: string;
    value: string;
    onChange: (html: string) => void;
    placeholder?: string;
}

const TOOLBAR_OPTIONS = [
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
];

export function HtmlEditorField({ label, value, onChange, placeholder }: HtmlEditorFieldProps) {
    const modules = useMemo(() => ({ toolbar: TOOLBAR_OPTIONS }), []);

    return (
        <FormControl>
            <FormLabel fontSize="sm" fontWeight="medium" mb={1}>
                {label}
            </FormLabel>
            <Box
                borderWidth="1px"
                borderColor="blackAlpha.200"
                borderRadius="md"
                overflow="hidden"
                sx={{
                    ".ql-toolbar": {
                        borderColor: "transparent",
                        borderBottom: "1px solid var(--chakra-colors-blackAlpha-200)",
                    },
                    ".ql-container": {
                        borderColor: "transparent",
                        fontSize: "14px",
                        minHeight: "160px",
                    },
                }}
            >
                <ReactQuill theme="snow" value={value} onChange={onChange} modules={modules} placeholder={placeholder} />
            </Box>
        </FormControl>
    );
}